import script from "./CreateAbsence.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateAbsence.vue?vue&type=script&lang=ts&setup=true"

import "./CreateAbsence.vue?vue&type=style&index=0&id=43506a0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43506a0c"]])

export default __exports__